import { BaseState } from '@/store/base-state';
import { Filters, TableOptions } from '@/types';
import { default_subpartner } from '../services';
import { Subpartners, SubpartnerFileUploadData } from '../types';

export default class SubpartnersState extends BaseState {
  subpartners: Subpartners.Subpartner[] = [];
  subpartners_loading = false;

  filters: Filters = {
    search: '',
    city: null,
    region: null,
  };

  current_subpartner = default_subpartner();

  regions: string[] = [];

  cities: string[] = [];

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['name_subpartner'],
    sortDesc: [true],
  };

  file_upload_details: SubpartnerFileUploadData = {
    fail_rows: null,
    success_rows: null,
    total_rows: null,
  }
}
